import NetworkUtil from "./NetworkUtil";
import { ServerResponse } from "../types/ServerResponse";

export default class ExemptionAPI {

  public static async filterExemptions(filter): Promise<{ success: boolean, reason: string, data }> {
    return NetworkUtil.makePost("/api/admin/exemption/filter", filter)
  }

  // Async export job endpoints (admin). createExport queues a background job;
  // listExports drives the Exports panel; downloadExport pulls a finished file.
  public static async createExport(filter, type?: 'admin' | 'expired'): Promise<{ success: boolean, reason?: string, jobId?: number }> {
    return NetworkUtil.makePost("/api/admin/exemption/exports", { filter, type });
  }

  public static async listExports(): Promise<{ success: boolean, reason?: string, jobs?: any[] }> {
    return NetworkUtil.makeGet("/api/admin/exemption/exports");
  }

  public static async downloadExport(id: number, fileName: string = "Exemption Records.xlsx"): Promise<boolean> {
    return NetworkUtil.downloadAuthedFile("/api/admin/exemption/exports/" + id + "/download", fileName);
  }

  public static async checkDuplicate(childFirstName: string, childLastName: string, childDOB: string, exemptionType: number): Promise<any> {
    return NetworkUtil.makePost("/api/admin/exemption/check-duplicate", {
      childFirstName,
      childLastName,
      childDOB,
      exemptionType
    });
  }

  public static async newExemption(exemptionInfo, ApprovalLetter?): Promise<ServerResponse> {
    let data = new FormData();
    data.set('exemptionInfo', JSON.stringify(exemptionInfo));
    if (ApprovalLetter) {
      data.append('approvalLetter', ApprovalLetter);
    }
    return await NetworkUtil.postForm("/api/admin/exemption/new", data);
  }

  public static async editExemption(body): Promise<ServerResponse> {
    return await NetworkUtil.makePost("/api/admin/exemption/edit", body);
  }

  public static async editSchoolInfo(body): Promise<ServerResponse> {
    return await NetworkUtil.makePost("/api/admin/exemption/edit/school-info", body);
  }

  public static async approveExemption(body): Promise<ServerResponse> {
    return await NetworkUtil.makePost("/api/admin/exemption/approve", body);
  }

  public static async denyExemption(body): Promise<ServerResponse> {
    return await NetworkUtil.makePost("/api/admin/exemption/deny", body);
  }

  // returns filePath of result report that is generated and stored in the cloud
  public static generateCertificateForReqNum(reqNum: string): Promise<{ success: boolean, reason: string, data }> {
    return NetworkUtil.makePost("/api/admin/pdfReport/generateResultReportForReqNum", { reqNum: reqNum })
  }

  public static viewCertificate(path: string): Promise<any> {
    return NetworkUtil.makePostForBuffer("/api/admin/pdfReport/viewCertificate", { path: path });
  }

  public static async getExemptionForApproval(body): Promise<ServerResponse> {
    return NetworkUtil.makePost("/api/admin/exemption/physicianapproval", body)
  }

  public static async updateExemptionStatus(exemption, status): Promise<ServerResponse> {
    if (status) {
      return await NetworkUtil.makePost("/api/admin/exemption/approve", exemption);
    } else {
      return await NetworkUtil.makePost("/api/admin/exemption/deny", exemption);
    }
  }

  public static getCertificateListForReqNum(reqNum: string): Promise<{ success: boolean, reason: string, data: [] }> {
    return NetworkUtil.makePost("/api/admin/pdfReport/getCertificateListForReqNum", { reqNum: reqNum });
  }


  public static async getFilteredExemptions(page, filter): Promise<{ success?: boolean, reason?: string, exemptions?, num_pages?: number, totalExemptions?: number, table_data?, errorCode?: string, message?: string }> {
    return NetworkUtil.makePost("/api/admin/exemption/search?page=" + page, filter);
  }

  public static async getFilteredPhysicianExemptions(page, filter): Promise<{ num_pages: number, totalExemptions: number, table_data?}> {
    return NetworkUtil.makePost("/api/admin/exemption/approvalsearch?page=" + page, filter);
  }

  public static async getFilteredExemptionsForApproval(filter): Promise<{ success: boolean, reason?, record?}> {
    return NetworkUtil.makePost("/api/system/exemption/approvalsearch", filter);
  }

  public static async sendPhysicianEmail(exemption): Promise<ServerResponse> {
    return NetworkUtil.makePost("/api/admin/exemption/resend", exemption);
  }

  public static async assignToFacility(exemptionID: number, facilityID?: number): Promise<ServerResponse> {
    return NetworkUtil.makePost("/api/admin/exemption/assignToFacility", { exemptionID, facilityID });
  }
}